import BaseEntity from '../BaseEntity.model';
import { Progress } from './Progress.model';

export default interface IBarrier extends BaseEntity {
    Name: string;
    Progress: Progress[];
    FactorAndRiskAssessmentId: string;
    IsFromCulturalConsiderations: boolean;
    CreatedAt: string;
    UpdatedAt: string;
}

export class Barrier implements IBarrier {
    Id: string | null;
    Name: string;
    Progress: Progress[];
    FactorAndRiskAssessmentId: string;
    IsFromCulturalConsiderations: boolean;
    CreatedAt: string;
    UpdatedAt: string;

    IsSelected: boolean;
    IsOpenProgress: boolean;
    NewProgressNote: string;

    constructor() {
        this.Id = null;
        this.Name = '';
        this.Progress = [] as Progress[];
        this.FactorAndRiskAssessmentId = '';
        this.IsFromCulturalConsiderations = false;
        this.IsSelected = false;
        this.IsOpenProgress = false;
        this.NewProgressNote = '';
        this.CreatedAt = '';
        this.UpdatedAt = '';
    }
}
